import { createGlobalStyle } from 'styled-components';
import fontsCss from './fonts.module.css';

export default createGlobalStyle`
 ${fontsCss}
`;
